import { Spinner } from '@frontend/components/common';
import { Check } from '@frontend/icons';
import { AnswerResult } from '@frontend/question/types';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { ProductCard } from '../browse-products-by-categories/product-card/product-card.component';
import { useReturnDetail } from './return-detail.controller';

export const ReturnDetail = () => {
    const viewProps = useReturnDetail();

    if (viewProps.isLoading) {
        return (
            <WizardScreenContainer>
                <div className='flex h-full w-full items-center justify-center'>
                    <Spinner className='text-border-default fill-brand-primary size-12' />
                </div>
            </WizardScreenContainer>
        );
    }

    // Check if user can continue - at least one answer with CONTINUE_WITH_VENDING result must be selected
    const canContinue =
        viewProps.questionsWithAnswers.size === 0 || viewProps.selectedAnswers.some((answer) => answer.result === AnswerResult.CONTINUE_WITH_VENDING);

    return (
        <WizardScreenContainer
            footer={{
                onBack: viewProps.onBack,
                onSubmit: viewProps.onSubmit,
                submitDisabled: !canContinue
            }}>
            <>
                <div className='flex flex-col gap-3 self-stretch'>
                    <p className='text-foreground-default font-medium'>
                        <FormattedMessage
                            id='kiosk.wizard.return-detail.returning'
                            defaultMessage='Returning'
                        />
                    </p>
                    <ProductCard
                        variant='attributes'
                        product={viewProps.product}
                    />
                </div>

                {viewProps.questionsWithAnswers.size > 0 && (
                    <div className='flex flex-col gap-3 self-stretch'>
                        {Array.from(viewProps.questionsWithAnswers.values()).map((qwa) => (
                            <div
                                key={qwa.question.id}
                                className='flex flex-col gap-3'>
                                <span className='text-foreground-default w-full justify-end text-base font-medium'>{qwa.question.question}</span>
                                <div className='flex flex-col gap-1'>
                                    {qwa.answers.map((answer) => (
                                        <div
                                            key={answer.id}
                                            className='bg-background-surface outline-border-default inline-flex items-center justify-start gap-4 self-stretch rounded-xl p-4 outline-1 -outline-offset-1'>
                                            <label className='relative flex h-5 w-5 cursor-pointer items-center justify-center'>
                                                <input
                                                    onClick={(e) =>
                                                        viewProps.setSelectedAnswers((prev) => {
                                                            const isChecked = (e.target as HTMLInputElement).checked;
                                                            if (isChecked) {
                                                                return [...prev, answer];
                                                            } else {
                                                                return prev.filter((a) => a.id !== answer.id);
                                                            }
                                                        })
                                                    }
                                                    type='checkbox'
                                                    className='peer absolute h-5 w-5 cursor-pointer appearance-none rounded border-2 border-gray-300 checked:border-black checked:bg-white'
                                                />
                                                <Check className='pointer-events-none absolute hidden h-4 w-4 text-black peer-checked:block' />
                                            </label>
                                            <div className='inline-flex flex-1 flex-col items-start justify-center gap-0.5'>
                                                <div className="text-foreground-default justify-start font-['Montserrat'] text-base font-medium">
                                                    {answer.answer}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </>
        </WizardScreenContainer>
    );
};
